import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import styles from './ProjectList.module.css'
import MainHeader from '../ReusableComponents/Header/MainHeader'
import { getDeviceNameWithVersion } from '../../utils/utils'
import renderPrgImage from '../../source/programImg'
import { connect } from 'react-redux'
import { projectsDetails } from '../../utils/projectsDetails'

function ProjectList(props) {
    let history = useHistory()

    const [projects, setProjects] = useState([])
    const [searchText, setSearchText] = useState('')
    const [suggestions, setSuggestions] = useState([])
    const [filterProject, setFilterProject] = useState([])

    // useEffect(() => {
    //     setProjects(
    //         projectsDetails?.[props?.selectedKit?.id]?.projectList ?? []
    //     )
    // }, [props?.selectedKit?.id])

    const handelGoBack = () => {
        history.push('/selection')
    }

    const handelCloudClick = () => {}

    //on change the search input box this function called
    const handelSearchChange = (e) => {
        let newSearchText = e.target.value.trim()
        setSearchText(newSearchText)

        if (!newSearchText.trim()) return setSuggestions([])
        let filters = projects.filter((project) =>
            project.name.toLowerCase().includes(newSearchText.toLowerCase())
        )
        setSuggestions(filters)
    }

    //on clicked the searched project this function called
    const handelClickSearchProject = (project, index) => {
        setSuggestions([])
        setFilterProject([project])
    }

    const handelProjectClick = (project) => {
        if (!project) {
            return
        }
        sessionStorage.setItem('buildProjectName', project.name)
        history.push('/project-page')
    }

    const handelSearchClear = () => {
        setSearchText('')
        setFilterProject([])
    }
    return (
        <div>
            <div>
                <MainHeader
                    title="Build Project"
                    titlePosition="left"
                    help_btnPosition="right"
                    // helper={}
                    // isShowSleep={true}
                    isGoBack={true}
                    goBack={handelGoBack}
                    isShowCloud={false}
                    handelCloudClick={handelCloudClick}
                    isShowSearchBar={true}
                    searchText={searchText}
                    handelSearchChange={handelSearchChange}
                    suggestions={suggestions}
                    handelClickSearchProject={handelClickSearchProject}
                    handelSearchClear={handelSearchClear}
                    filterProject={filterProject}
                />
            </div>

            {/* ---------- body ---------------------------------------- */}
            <div className={styles.projectListWrapper}>
                {/* Body */}
                <div className={styles.projectGrid}>
                    {filterProject.length > 0
                        ? filterProject.map((project) => (
                              <div
                                  key={project.id}
                                  className={styles.projectCard}
                                  onClick={() => handelProjectClick(project)}
                              >
                                  <div className={styles.imageWrapper}>
                                      <img
                                          src={project.image}
                                          alt={project.name}
                                          className={styles.projectImage}
                                      />
                                  </div>
                                  <div className={styles.projectName}>
                                      {project.name}
                                  </div>
                              </div>
                          ))
                        : projects.map((project) => (
                              <div
                                  key={project.id}
                                  className={styles.projectCard}
                                  onClick={() => handelProjectClick(project)}
                              >
                                  <div className={styles.imageWrapper}>
                                      <img
                                          src={project.image}
                                          alt={project.name}
                                          className={styles.projectImage}
                                      />
                                  </div>
                                  <div className={styles.projectName}>
                                      {project.name}
                                  </div>
                              </div>
                          ))}
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return { selectedKit: state.device?.kitSelection?.selectedKit }
}
const mapDispatchToProps = (dispatch) => {
    return {
        // setLanguageSelect: (data) => {
        //     dispatch(setLanguageSelect(data))
        // },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ProjectList)
